<template>
	<BaseTooltip
		class="h-6 relative flex items-center justify-center"
		:title="isSaved == true ? lang.undo_save_job[locale] : lang.save_job[locale]"
	>
		<span
			@click.stop="toggleSaved"
			class="material-icons-outlined cursor-pointer z-10"
			:class="isSaved ? 'icon-checked' : 'icon-unchecked'"
		>
			{{ isSaved ? "favorite" : "favorite_border" }}
		</span>
	</BaseTooltip>
</template>

<script lang="ts">
import BaseTooltip from "~/ui-kit/components/BaseTooltip.vue";
import { defineComponent, type PropType, ref } from "vue";
import type { JobCardsLang } from "~/ui-kit/types/types";

export default defineComponent({
	name: "DjCardSaveJob",
	components: { BaseTooltip },
	props: {
		isSaved: {
			type: Boolean,
			default: false,
		},
		lang: {
			type: Object as PropType<JobCardsLang["card"]>,
			default: () => {
				return {};
			},
		},
		locale: {
			type: String,
			default: "hu",
		},
	},
	setup(props, { emit }) {
		function toggleSaved() {
			emit("toggleSaved");
		}

		return {
			toggleSaved,
		};
	},
});
</script>

<style scoped>
.icon-checked {
	@apply text-dj-red hover:text-dj-gray before:block before:absolute before:w-dj-40 before:h-dj-40 before:rounded-full before:top-1/2 before:left-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before:bg-dj-pink;
}

.icon-unchecked {
	@apply text-dj-gray hover:text-dj-red;
}
</style>
